export default "__VITE_ASSET__97a24d1d__"